import { render, staticRenderFns } from "./AmericanExpressIcon.vue?vue&type=template&id=0a4ff210&"
import script from "./AmericanExpressIcon.vue?vue&type=script&lang=js&"
export * from "./AmericanExpressIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports